import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import XButton from "../common/XButton";

const DemandStudioDeleteCommentsButton = () => {
  const { hasAnyComments, isSaving, clearAllComments } = useDemandStudioContext();

  return (
    <XButton
      variant="outlinePrimary"
      size="sm"
      onClick={clearAllComments}
      disabled={!hasAnyComments || isSaving}
    >
      Delete All Comments
    </XButton>
  );
};

export default DemandStudioDeleteCommentsButton;
